import React from 'react';
import { LineChart } from 'react-native-chart-kit';
import { Dimensions, View, Text } from 'react-native';
import LottieView from 'lottie-react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { MODERN_CHART_COLORS } from '@utils/chartTheme';
import ModernChartWrapper from './ModernChartWrapper';

interface ActivityLineChartProps {
  data?: any;
  isLoading?: boolean;
  chartConfig?: any;
  width?: number;
  height?: number;
}

const ActivityLineChart: React.FC<ActivityLineChartProps> = ({
  data,
  isLoading = false,
  chartConfig,
  width = 280,
  height = 180
}) => {
  const theme = themeSelector();
  const summaryData = [
    { label: 'Peak Activity', value: '89%', color: MODERN_CHART_COLORS.line.primary },
    { label: 'Avg Usage', value: '65%', color: MODERN_CHART_COLORS.line.secondary },
    { label: 'Growth', value: '+12%', color: MODERN_CHART_COLORS.line.tertiary }
  ];

  const loadingComponent = (
    <LottieView
      style={{ height: 150, alignSelf: 'center' }}
      source={require("@assets/animations/spin-leaf-loader.json")}
      autoPlay
      loop
    />
  );

  return (
    <ModernChartWrapper
      title="Weekly Activity"
      subtitle="Track your weekly activity patterns"
      isLoading={isLoading}
      loadingComponent={loadingComponent}
      summaryData={summaryData}
      minHeight={320}
      minWidth={340}
    >
      {data ? (
        <LineChart
          data={data}
          width={width}
          height={height}
          chartConfig={chartConfig}
          bezier
          style={{ borderRadius: 10 }}
        />
      ) : (
        <View style={{
          height: height,
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Text style={{ color: theme ? '#64748b' : '#94a3b8' }}>
            No activity data available
          </Text>
        </View>
      )}
    </ModernChartWrapper>
  );
};

export default ActivityLineChart;
